export default __webpack_public_path__ + "static/Short-10fd6f74c89d9c18caf177728a0ccd28.webp";